import axiosAuth from '../../axiosMain';

async function show(company_id, data = null) {
  try {
    let response = await axiosAuth.post('/company_answers/' + company_id, data);
    return response.data.data;
  } catch (e) {}
}

export default {
  show,
};
